const EVENT_TIMEOUT_MS = 2000;
const EVENT_MIN_WAIT_MS = 500;

function getDataLayer() {
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
}

/**
 * Єдина точка відправки подій у Google Analytics:
 * 1) dataLayer — щоб GTM міг зловити подію і відправити в GA4
 * 2) gtag — щоб подія потрапила в GA навіть без окремого тега в GTM
 */
export function trackEvent(eventName, params = {}, { callback } = {}) {
    const payload = { ...params };
    getDataLayer().push({ event: eventName, ...payload });

    if (typeof callback !== 'function') {
        if (typeof window.gtag === 'function') {
            window.gtag('event', eventName, {
                ...payload,
                transport_type: 'beacon',
            });
        }
        return;
    }

    let finished = false;
    const startedAt = Date.now();

    const done = () => {
        if (finished) return;
        const waitMore = Math.max(0, EVENT_MIN_WAIT_MS - (Date.now() - startedAt));
        window.setTimeout(() => {
            if (finished) return;
            finished = true;
            callback();
        }, waitMore);
    };

    if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, {
            ...payload,
            transport_type: 'beacon',
            event_timeout: EVENT_TIMEOUT_MS,
            event_callback: done,
        });
        window.setTimeout(done, EVENT_TIMEOUT_MS);
        return;
    }

    window.setTimeout(done, EVENT_MIN_WAIT_MS);
}

export function trackPageView(path) {
    const pagePath = path || window.location.pathname + window.location.search;
    const payload = {
        page_path: pagePath,
        page_location: window.location.href,
        page_title: document.title,
    };

    getDataLayer().push({ event: 'virtual_page_view', ...payload });

    if (typeof window.gtag === 'function') {
        window.gtag('event', 'page_view', payload);
    }
}

export function trackPhoneClick(phone) {
    trackEvent('phone_click', {
        phone,
        event_category: 'engagement',
    });
}

export function trackEmailClick(email) {
    trackEvent('email_click', {
        email,
        event_category: 'engagement',
    });
}

export function trackMenuClick(menuItem) {
    trackEvent('menu_click', {
        menu_item: menuItem,
        event_category: 'navigation',
    });
}

export function trackFormLead(data = {}, callback) {
    const value = Number(data.price) || 2500;

    trackEvent('generate_lead', {
        form_type: 'registration',
        form_name: 'Registration Form',
        value,
        currency: 'UAH',
        event_category: 'form',
    }, { callback });
}
